import { render, staticRenderFns } from "./synchronization.vue?vue&type=template&id=23a697e8&scoped=true"
import script from "./synchronization.vue?vue&type=script&lang=js"
export * from "./synchronization.vue?vue&type=script&lang=js"
import style0 from "./synchronization.vue?vue&type=style&index=0&id=23a697e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a697e8",
  null
  
)

export default component.exports